import logo from './logo.svg';
import './App.css';
import BarChart from "./BarChart";
import LineChart from "./LineChart";

import Header from "./Header";
import { VeltProvider, VeltComments, VeltCommentsSidebar } from '@veltdev/react';
function App() {
  return (
    <VeltProvider apiKey='j3AwoBkuQMTEgeqrmPve'>
      <Header />
      <VeltComments />
      <VeltCommentsSidebar />

      <div className='dashboard-container'>
        <BarChart />
        <LineChart />
      </div>

    </VeltProvider>
  )
}

export default App;
